
export const root = {
    transitionDuration: '{transition.duration}'
};

export const track = {
    background: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    size: '3px'
};

export const range = {
    background: '{primary.color}'
};

export const handle = {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    background: '{primary.color}',
    hoverBackground: '{primary.color}',
    content: {
        borderRadius: '50%',
        hoverBackground: '{primary.color}',
        width: '12px',
        height: '12px',
        shadow: 'none'
    },
    focusRing: {
        width: '{form.field.focus.ring.width}',
        style: '{form.field.focus.ring.style}',
        color: '{form.field.focus.ring.color}',
        offset: '{form.field.focus.ring.offset}',
        shadow: '{form.field.focus.ring.shadow}'
    }
};

export const colorScheme = {
    light: {
        handle: {
            content: {
                background: '{surface.0}'
            }
        }
    },
    dark: {
        handle: {
            content: {
                background: '{surface.950}'
            }
        }
    }
};

export default {
    root,
    track,
    range,
    handle,
    colorScheme
};
